import { render, staticRenderFns } from "./UserCenterHeaderBar.vue?vue&type=template&id=08cca9ae&scoped=true"
import script from "./UserCenterHeaderBar.vue?vue&type=script&lang=js"
export * from "./UserCenterHeaderBar.vue?vue&type=script&lang=js"
import style0 from "./UserCenterHeaderBar.vue?vue&type=style&index=0&id=08cca9ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cca9ae",
  null
  
)

export default component.exports